import { NoDisplayType } from '../DisplayTypes';
import { NoInputType } from '../InputTypes';
import { makeOperator } from './Operator';

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ displayType: "NONE"; inputType... Remove this comment to see the full error message
export default makeOperator({
  displayType: NoDisplayType,
  inputType: NoInputType,
  name: 'WebinarHasAttended'
});